<template>
    <div class="container-fluid mtb15 no-fluid">
        <div class="row sm-gutters">
            <!-- Menu -->
            <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
                <AppMenu></AppMenu>
            </div>
            <div class="col-sm-12" :class="{ 'col-md-10': 1200 < getWindowsWidth }">
                <!-- header -->
                <div class="row align-items-center wallet-detail-header">
                    <div class="col-sm-1 wallet-detail-back">
                        <!-- back button -->
                        <button class="btn btn btn-outline-secondary btn-light mb-2" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                            @click.prevent="goBack()">&larr;</button>
                    </div>
                    <div class="col-sm-11 wallet-detail-title">
                        <!-- view header -->
                        <h5 v-if="1200 < getWindowsWidth">{{ t("transactionsLabel") }} - #{{ transaction?.id }}</h5>
                        <h6 v-else>{{ t("transactionsLabel") }} - #{{ formatTransactionId(transaction?.id) }}</h6>
                    </div>
                </div>
                <!-- transaction details -->
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ t("timestampLabel") }}</td>
                                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{
                                    getDate(transaction?.ts) }}</td>
                            </tr>
                            <tr>
                                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ t("typeLabel") }}</td>
                                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{
                                    capitalizeFirstLetter(transaction.tt) }}</td>
                            </tr>
                            <tr>
                                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ t("currencyLabel") }}</td>
                                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ transaction?.cc
                                }}</td>
                            </tr>
                            <tr>
                                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ t("amountLabel") }}</td>
                                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                                    {{ formatPrice(transaction.am, transaction.cc).replace(' ', '&nbsp;') }}
                                </td>
                            </tr>
                            <tr>
                                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" colspan="2">
                                    {{ t("noteLabel") }}<br />
                                    <strong>{{ transaction?.note }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppMenu from '@/components/ui/AppMenu.vue';
import I18n from "@/lang/i18n.js";
import UiUtils from "@/assets/js/ui_utils.js";
import { getOrderActionLabel } from "@/features/wallet/wallet-label-formatters";

export default {
    components: {
        AppMenu
    },
    data() {
        return {
            transaction: JSON.parse(this.transactionDetails)
        }
    },
    props: {
        transactionDetails: {
            required: true,
            type: String,
            default: null
        },
        latestDisplayStock: {
            required: false,
            type: String,
            default: null
        }
    },
    methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
        getDate(unix) {
            return UiUtils.parseUnixTime(unix);
        },
        getOrderType(ot) {
            return getOrderActionLabel(ot, {
                buy: this.t("buyLabel"),
                sell: this.t("sellLabel")
            });
        },
        parseNumber(num) {
            return UiUtils.formatNumber(num);
        },
        goBack() {
            // if latestDisplayStock is not null the this is details for exchanges breakdown and we need it to display appropriate list of transactions
            this.$router.push({ name: "Wallet", params: { latestActiveMenuSelection: "Transactions", latestDisplayStock: this.latestDisplayStock } });
        },
        capitalizeFirstLetter(string) {
            return string
                ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
                : "";
        },
        formatPrice(val, curr) {
            return UiUtils.formatPrice(val, curr, this.getUserLanguage);
        },
        formatTransactionId(id) {
            if (16 > id.length) {
                return id;
            }
            return id.slice(16) + "..."
        }
    },
    computed: {
        getWindowsWidth() {
            return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
    },
    mounted() {
        window.onpopstate = function () {
            this.goBack();
        }.bind(this);
    }
}
</script>

<style scoped>
.wallet-detail-header {
    flex-wrap: nowrap;
}

.wallet-detail-back {
    flex: 0 0 auto;
    width: auto;
}

.wallet-detail-title {
    flex: 1 1 auto;
    width: auto;
}

.wallet-detail-title h5,
.wallet-detail-title h6 {
    margin-bottom: 0.5rem;
}

.prop-value {
    text-align: right;
    font-weight: bold;
}

.xxsmall-font-size {
    font-size: xx-small;
}

.xsmall-font-size {
    font-size: x-small;
}
</style>
